// extracted by mini-css-extract-plugin
export var deleteModal = "_gi-0";